import React from 'react';
import AdminAppBody from '../../../components/admin/AdminAppBody';
import PageHeading from '../../../components/admin/common/PageHeading';

const Add = () => {
    return (
        <AdminAppBody
            content={
                <div className="container">
                    <PageHeading
                        title="Add New Student"
                        subTitle="Fill out the details below to register a new student."
                    />

                    <div className="card p-4 shadow-sm mt-3">
                        <h6 className="fw-semibold mb-4">Student Registration Form</h6>
                        <form>
                            <div className="row">
                                {/* Row 1 */}
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="name" className="form-label">Name</label>
                                    <input type="text" className="form-control py-2" id="name" placeholder="Enter name" />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="email" className="form-label">Email</label>
                                    <input type="email" className="form-control py-2" id="email" placeholder="Enter email" />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="phone" className="form-label">Phone</label>
                                    <input type="tel" className="form-control py-2" id="phone" placeholder="Enter phone number" />
                                </div>

                                {/* Row 2 */}
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="dob" className="form-label">Date of Birth</label>
                                    <input type="date" className="form-control py-2" id="dob" />
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="gender" className="form-label">Gender</label>
                                    <select className="form-select py-2" id="gender">
                                        <option value="">Select gender</option>
                                        <option value="male">Male</option>
                                        <option value="female">Female</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>
                                <div className="col-md-4 mb-3">
                                    <label htmlFor="course" className="form-label">Course</label>
                                    <input type="text" className="form-control py-2" id="course" placeholder="Enter course name" />
                                </div>

                                {/* Row 3 */}
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="rollNumber" className="form-label">Roll Number</label>
                                    <input type="text" className="form-control py-2" id="rollNumber" placeholder="Enter roll number" />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label htmlFor="address" className="form-label">Address</label>
                                    <input type="text" className="form-control py-2" id="address" placeholder="Enter address" />
                                </div>

                                {/* Textarea */}
                                <div className="col-12 mb-4">
                                    <label htmlFor="note" className="form-label">Additional Notes</label>
                                    <textarea className="form-control py-2" id="note" rows="4" placeholder="Enter any additional notes"></textarea>
                                </div>
                            </div>

                            <button type="submit" className="btn btn-primary">Register</button>
                        </form>
                    </div>
                </div>
            }
        />
    );
};

export default Add;
